// Offers routes
export default [
  {
    path: 'signature-profiles',
    name: 'signature-profiles',
    redirect: 'signature-profiles/index',
    component: () =>
      import(
        /* webpackChunkName: "signatureProfiles" */ '../views/signatureProfiles/SignatureProfiles.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'signatureProfilesIndex',
        meta: {
          tabbable: true,
          tableKeys: ['signatureProfiles'],
          filterKeys: ['signatureProfiles'],
          formKeys: [],
          routePermissions: ['signatureManage'],
        },
        component: () =>
          import(
            /* webpackChunkName: "signatureProfilesIndex" */ '../views/signatureProfiles/SignatureProfilesIndex.vue'
          ),
      },
    ],
  },
];
